
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { cn } from "../lib/utils";

const Navigation = () => {
  const location = useLocation();
  
  const links = [
    { to: "/", label: "About" },
    { to: "/fortune", label: "Daily Fortune" },
    { to: "/history", label: "History" },
    { to: "/recipe", label: "Recipe" },
    { to: "/create-fortune", label: "Create Your Own" },
    { to: "/faq", label: "FAQs" },
  ];

  return (
    <nav className="mb-6">
      <motion.div 
        className="flex flex-wrap justify-center gap-4 text-sm"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {links.map((link) => {
          const isActive = location.pathname === link.to;
          
          return (
            <Link 
              key={link.to} 
              to={link.to}
              className={cn(
                "px-3 py-2 rounded-md transition-colors relative",
                isActive 
                  ? "text-foreground font-medium" 
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              {link.label}
              {isActive && (
                <motion.div
                  className="absolute bottom-0 left-0 right-0 h-0.5 bg-cookie-dark mx-3"
                  layoutId="navIndicator"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                />
              )}
            </Link>
          );
        })}
      </motion.div>
    </nav>
  );
};

export default Navigation;
